/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .constant('FILE_DRAG_OVER_CLASS', 'nv-file-over')
    .constant('FILE_DROP_EVENT', {
        DROPPED: 'fileDrop.dropped'
    })
    .directive('accFileDropZone', [
        'FILE_DRAG_OVER_CLASS',
        function (FILE_DRAG_OVER_CLASS) {
            return {
                restrict: 'A',
                require: '^^accFileDrop',
                scope: {
                    target: '<accFileDropZone'
                },
                link: function ($scope, $element, _, FileDropController) {
                    if (!angular.isObject($scope.target)) {
                        return;
                    }

                    var delistDropZone;

                    // Handle the case when target is Resource in loading state
                    if (angular.isDefined($scope.target.$promise)) {
                        $scope.target.$promise.then(_initDropZone);
                    } else {
                        _initDropZone();
                    }

                    $scope.$on('$destroy', function () {
                        if (angular.isFunction(delistDropZone)) {
                            delistDropZone();
                        }
                    });

                    function _initDropZone() {
                        if ($scope.target.is_directory && !$scope.target.is_deleted && !$scope.target.read_only) {
                            $element.on('dragenter dragleave', _onDragEnterLeaveHandler);
                            delistDropZone = FileDropController.registerDropZone($scope.target, $element.get(0));
                        }
                    }

                    function _onDragEnterLeaveHandler(event) {
                        event.stopPropagation();

                        /**
                         * Preventing drag'n'drop files with Esc click
                         */
                        if (event.type === 'dragleave' && event.screenX === 0 && event.screenY === 0) {
                            $element.removeClass(FILE_DRAG_OVER_CLASS);
                            FileDropController.target = null;
                        } else if (
                            FileDropController.target !== $scope.target ||
                            FileDropController.element !== $scope.element
                        ) {
                            $('.' + FILE_DRAG_OVER_CLASS).removeClass(FILE_DRAG_OVER_CLASS);
                            $element.addClass(FILE_DRAG_OVER_CLASS);
                            FileDropController.target = $scope.target;
                            FileDropController.element = $element.get(0);
                        }
                    }
                }
            }
        }
    ])
    .directive('accFileDrop', [
        'FILE_DRAG_OVER_CLASS',
        function (FILE_DRAG_OVER_CLASS) {
            /**
             * The main idea of this directive is to have one drag'n'drop handler
             * for the whole app. The directive should be used only once with body-element.
             */
            var handlersAreSet = false;
            var currentTarget = null;
            var currentElement = null;
            var dropZones = [];

            return {
                restrict: 'A',
                controller: [
                    '$element',
                    '$rootScope',
                    'FILE_DROP_EVENT',
                    function ($element, $rootScope, FILE_DROP_EVENT) {
                        if ($element.get(0).tagName !== 'BODY' || handlersAreSet) {
                            return;
                        }

                        Object.defineProperties(this, {
                            target: {
                                enumerable: true,
                                configurable: false,
                                get: function () {
                                    return currentTarget;
                                },
                                set: function (target) {
                                    currentTarget = target;
                                }
                            },
                            element: {
                                enumerable: true,
                                configurable: false,
                                get: function () {
                                    return currentElement;
                                },
                                set: function (element) {
                                    currentElement = element;
                                }
                            },
                            registerDropZone: {
                                enumerable: false,
                                configurable: false,
                                value: function (target, element) {
                                    var dropZone = {
                                        target: target,
                                        element: element,
                                        depth: $(element).parents().length
                                    };
                                    var insertIndex = -1;

                                    do {
                                        insertIndex += 1;
                                    } while (angular.isDefined(dropZones[insertIndex]) && dropZones[insertIndex].depth <= dropZone.depth);

                                    dropZones.splice(insertIndex, 0, dropZone);

                                    return function () {
                                        var dropZoneIndex = dropZones.indexOf(dropZone);

                                        if (currentTarget === dropZone.target) {
                                            currentTarget = null;
                                        }

                                        dropZones.splice(dropZoneIndex, 1);
                                    };
                                }
                            }
                        });

                        var onDragEnterLeaveHandler = _toggleDragDropHandler(function () {
                            return function (event) {
                                event.stopPropagation();

                                var topMostDropZone = dropZones[0];

                                if (angular.isUndefined(topMostDropZone)) {
                                    return;
                                }

                                /**
                                 * Preventing drag'n'drop files with Esc click
                                 */
                                if (event.type === 'dragleave' && event.screenX === 0 && event.screenY === 0) {
                                    $('.' + FILE_DRAG_OVER_CLASS).removeClass(FILE_DRAG_OVER_CLASS);
                                    currentTarget = null;
                                } else if (currentTarget !== topMostDropZone.target) {
                                    $('.' + FILE_DRAG_OVER_CLASS).removeClass(FILE_DRAG_OVER_CLASS);
                                    $(topMostDropZone.element).addClass(FILE_DRAG_OVER_CLASS);

                                    currentTarget = topMostDropZone.target;
                                }
                            };
                        }());

                        var onDragEndHandler = _toggleDragDropHandler(function () {
                            $('.' + FILE_DRAG_OVER_CLASS).removeClass(FILE_DRAG_OVER_CLASS);
                        });

                        var onDragOverHandler = _toggleDragDropHandler(function (event) {
                            event.preventDefault();
                        });

                        var onDropHandler = _toggleDragDropHandler(function (event) {
                            event.preventDefault();
                            var dataTransfer = event.originalEvent.dataTransfer;
                            var droppedFiles = dataTransfer.files;

                            if (droppedFiles.length === 0) {
                                return;
                            }

                            if (!currentTarget) {
                                return;
                            }

                            $('.' + FILE_DRAG_OVER_CLASS).removeClass(FILE_DRAG_OVER_CLASS);
                            $rootScope.$broadcast(FILE_DROP_EVENT.DROPPED, currentTarget, dataTransfer);
                            currentTarget = null;
                        });

                        $element
                            .on('dragenter dragleave', onDragEnterLeaveHandler)
                            .on('dragover', onDragOverHandler)
                            .on('dragend', onDragEndHandler)
                            .on('drop', onDropHandler);

                        // We intentionally break the default browser behavior.
                        // User won't be able to open files in browser by dropping them
                        $(document).on('dragstart dragenter dragover dragleave dragend drop', function ($event) {
                            $event.stopPropagation();
                            $event.preventDefault();
                        });

                        handlersAreSet = true;

                        /**
                         * Drag event wrapper with preliminary check
                         * if we'll need to handle drop events
                         * 
                         * @param {Function} handler Drag'n'Drop handler function
                         * @returns {Function} Wrapped handler
                         */
                        function _toggleDragDropHandler(handler) {
                            return function (event) {
                                if (dropZones.length <= 0) {
                                    return;
                                }

                                handler(event);
                            };
                        }
                    }
                ]
            };
        }]);
